import React from 'react'
import { Dialog, Bold } from '~/components'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import clsx from 'clsx'
import { DialogProps } from '../Dialog'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: mutualTheme.spacing(1),
    paddingTop: mutualTheme.spacing(0)
  },
  description: {
    textAlign: 'center',
    marginBottom: mutualTheme.spacing(3)
  }
})

export type UploadDialogProps = {
  title: string,
  isVisible: boolean,
  description: string,
  onClose: () => void,
  containerClassName?: string,
  uploadInputComponent?: JSX.Element
} & DialogProps

export const UploadDialog: React.FC<UploadDialogProps> = (props) => {
  const { containerClassName, uploadInputComponent, title, description, isVisible, onClose, children, maxWidth } = props
  const classes = useStyles()

  return (
    <Dialog maxWidth={maxWidth || 'md'} isVisible={isVisible} onClose={onClose}>
      <Box className={clsx(classes.container, containerClassName)}>
        <Typography variant='airbnbH2' sx={{ fontWeight: 700, textAlign: 'center' }}>{title}</Typography>
        <Typography variant='airbnbBody1' className={classes.description}><Bold>Pendência: </Bold>{description}</Typography>
        {children || uploadInputComponent}
      </Box>
    </Dialog>
  )
}
